//utils
import { challengesIndex, companiesIndex, profilesIndex, clientsIndex } from "utils/algolia";

const updateChallengeSearchResults = payload => ({
  type: "SET_CHALLENGE_RESULTS",
  payload
});

const updateCompanySearchResults = payload => ({
  type: "SET_COMPANY_RESULTS",
  payload
});

const updateProfileSearchResults = payload => ({
  type: "SET_PROFILE_RESULTS",
  payload
});

export const updateClientsSearchResults = payload => ({
  type: "SET_CLIENT_RESULTS",
  payload
});

export const searchChallenges = (input = "") => {
  return dispatch => {

    return challengesIndex.search(
      {
        query: input
      },
      (err, content) => {
        // console.log("searchChallenges", content, "err", err);

        if (!err) {
          return dispatch(updateChallengeSearchResults(content));
        }
      }
    );

  };
};

export const searchCompanies = (input = "") => {
  // console.log("searchCompanies", input);

  return dispatch => {
    return companiesIndex.search(
      {
        query: input,
        hitsPerPage: 500,
      },
      (err, content) => {
        if (!err) {
          return dispatch(updateCompanySearchResults(content));
        }
      }
    );
  };
};

export const searchProfiles = (input = "") => {
  return dispatch => {
    return profilesIndex.search(
      {
        query: input,
        hitsPerPage: 500,
      },
      (err, content) => {
        if (!err) {
          return dispatch(updateProfileSearchResults(content));
        }
      }
    );
  };
};

export const searchClients = (input = "") => {
  // console.log("searchClients", input);

  return dispatch => {
    return clientsIndex.search(
      {
        query: input,
        hitsPerPage: 500
      },
      (err, content) => {
        if (!err) {
          return dispatch(updateClientsSearchResults(content));
        }
      }
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/search.js